module.exports = "<vb-content-page-view>\r\n\r\n  <h1 page-title>Material verheiraten</h1>\r\n\r\n  <div page-content>\r\n      <vb-asset-marriage-wizard></vb-asset-marriage-wizard>\r\n  </div>\r\n\r\n</vb-content-page-view>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/visbos-touch-client/ui/touch-marriage/touch-marriage-wizzard/touch-marriage-wizzard.component.html
// module id = ./src/app/visbos-touch-client/ui/touch-marriage/touch-marriage-wizzard/touch-marriage-wizzard.component.html
// module chunks = main